import { z } from 'zod/v4';

export const pcmWsAvoidFavorLinkSchema = z.object({
  AFGroupID: z.number().nullable(),
  AvoidFavorID: z.number(),
  AvoidFavorType: z.number(),
  Comment: z.string().nullable(),
  Geometries: z.array(z.array(z.array(z.number()))),
  GridID: z.number(),
  GridLevel: z.number(),
  LinkID: z.number(),
  PLIDs: z.array(z.number()),
});

export type PcmWsAvoidFavorLink = z.infer<typeof pcmWsAvoidFavorLinkSchema>;
